import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDelayUnmount } from "../../hooks/useDelayUnmount";
import { Link } from "react-router-dom";
import { GlobalLoading } from "../../redux/actions/loading/loadingActions";
import { logout } from "../../redux/actions/auth/authActions";

import "./styles.css";

import { Navbar } from "react-bootstrap";
import CurrencySelector from "./CurrencySelector";

import { ReactComponent as Logo } from "../../assets/hippo-services-logo/svg/hotelsHippo.svg";
import hippoicon from "../../assets/hippoicon.png";
import dropdown_menu from "../../assets/dropdown_menu.png";
import GlobalImage from "../global/image/image";
import NotificationBadge from "../global/notification-badge";
import { ReactComponent as NotificationIcon } from "../../assets/header-icons/notification.svg";
import { ReactComponent as DashBoardIcon } from "../../assets/header-icons/dashboard.svg";
import { ReactComponent as ReservationsIcon } from "../../assets/header-icons/reservations.svg";
import { ReactComponent as MessagesIcon } from "../../assets/header-icons/messages.svg";
import { ReactComponent as LogoutIcon } from "../../assets/header-icons/logout.svg";

function Header() {
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.profile?.userDetails);
  const access_token = useSelector((state) => state?.auth?.access_token);

  const [showPop, setShowPop] = useState(false);
  const [showNavigationPop, setShowNavigationPop] = useState(false);

  const popRef = React.useRef(null);
  const togglerRef = React.useRef(null);

  const show = useDelayUnmount(showPop, 300);

  const handleClickOutside = (event) => {
    const conditon1 = popRef.current && !popRef.current.contains(event.target);
    const conditon2 = togglerRef.current && !togglerRef.current.contains(event.target);

    if (conditon1 && conditon2) {
      setShowPop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleFocusIn(event) {
      const target = event.target;
      const parent = target.offsetParent;

      if (!showPop) return;

      if (parent?.id !== "dropdownMenu" && target.id !== "navbarDropdown") {
        setShowPop(false);
      }
    }

    document.addEventListener("focusin", handleFocusIn);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
    };
  }, [showPop, setShowPop]);

  function logoutUser() {
    const payload = {
      access_token,
    };

    dispatch(GlobalLoading(true));

    dispatch(logout(payload)).finally(() => {
      dispatch(GlobalLoading(false));
    });
  }

  const NavhambergPopUp = () => {
    setShowNavigationPop(true);
  };

  const ProfileNavPopUp = () => {
    setShowNavigationPop(true);
  };

  const { unreadMessagesCount = 10, unreadNotificationsCount = 10 } = user || {};
  const unReadTotalCount = unreadMessagesCount + unreadNotificationsCount;

  const userId = user?.id;

  return (
    <header className="container header-container">
      <a href="/">
        <Navbar.Brand>
          <Logo className="hotels-hippo header-logo" />
        </Navbar.Brand>
      </a>

      <div className="header-right-section">
        <CurrencySelector />

        {user?.id ? (
          <React.Fragment>
            <Link to="/dashboard/notifications" className="header-notification-button">
              <NotificationIcon className="header-notification-icon" />
              <NotificationBadge count={unreadNotificationsCount} className="header-outer" />
            </Link>
            <button
              id="navbarDropdown"
              className="user_sec header-pop-toggler pop-up-elm profile-icon-deactive"
              ref={togglerRef}
              onClick={() => setShowPop((old) => !old)}
              aria-haspopup="true"
              aria-expanded={showPop}
              aria-controls="dropdownMenu"
            >
              <GlobalImage src={user.avatar} alt="user profile image" className="user_img" />
            </button>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-7 h-7 entry-hamberg-icon"
              onClick={ProfileNavPopUp}
            >
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="entry-button-section">
              <Link to={`/signin`} className="">
                <button className="entry-links">Login</button>
              </Link>
              |
              <Link className="" to={`/signup`}>
                <button className="entry-links">Register</button>
              </Link>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-7 h-7 entry-hamberg-icon"
              onClick={NavhambergPopUp}
            >
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </React.Fragment>
        )}
      </div>

      <SideNavigationPopUp
        setShowNavigationPop={setShowNavigationPop}
        showNavigationPop={showNavigationPop}
        userId={userId}
        show={show}
        showPop={showPop}
        popRef={popRef}
        user={user}
        unreadMessagesCount={unreadMessagesCount}
        unreadNotificationsCount={unreadNotificationsCount}
        logoutUser={logoutUser}
        togglerRef={togglerRef}
        setShowPop={setShowPop}
        unReadTotalCount={unReadTotalCount}
      />

      {show && user?.id && (
        <div
          id="dropdownMenu"
          className={`header-pop user_detail ${show && !showPop && "pop-unmounting"}`}
          ref={popRef}
          role="menu"
          aria-labelledby="navbarDropdown"
        >
          {/* <div className="user_detail_top">
            <div className="user_img">
              <GlobalImage src={user.avatar} alt="user profile image" />
            </div>

            <div className="user_info">
              <h6>{user.firstName}</h6>
              <Link to="/dashboard/profile/edit?type=general">Edit account</Link>
            </div>
          </div> */}
          {/* <hr /> */}
          <div className="user_info">
            <h6>Hi, {user.firstName}</h6>
          </div>

          <nav>
            <ul>
              <li>
                <Link to="/dashboard">
                  <span className="header-nav-icon">
                    <DashBoardIcon />
                  </span>
                  <span>Dashboard</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard/bookings?phase=request&page=1">
                  <span className="header-nav-icon">
                    <ReservationsIcon />
                  </span>
                  <span>Reservations</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard/messages">
                  <span className="header-nav-icon">
                    <MessagesIcon />
                  </span>
                  <span>Messages</span>
                  <NotificationBadge count={unreadMessagesCount} className="header-inner" />
                </Link>
              </li>
              <li>
                <button onClick={logoutUser}>
                  <span className="header-nav-icon">
                    <LogoutIcon />
                  </span>
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}

      {show && !user?.id && (
        <div
          id="dropdownMenu"
          className={`header-pop non-user-pop ${show && !showPop && "pop-unmounting"}`}
          ref={popRef}
          role="menu"
          aria-labelledby="navbarDropdown"
        >
          <GlobalImage src={hippoicon} alt="" />
          <Link to={`/signin`} className="header-sign-in">
            Sign in
          </Link>
          <Link className="header-sign-up" to={`/signup`}>
            Create an account
          </Link>
        </div>
      )}
    </header>
  );
}

export default Header;

function SideNavigationPopUp({
  showNavigationPop,
  setShowNavigationPop,
  userId,
  show,
  showPop,
  popRef,
  user,
  unreadMessagesCount,
  unreadNotificationsCount,
  logoutUser,
  togglerRef,
  setShowPop,
  unReadTotalCount,
}) {
  const CloseNavPopUp = () => {
    setShowNavigationPop(false);
  };

  const bodyElement = document.body;
  if (showNavigationPop) {
    bodyElement.style.overflow = "hidden";
  } else {
    bodyElement.style.overflow = "auto";
  }

  const goToPartner = () => {
    window.open("https://partner.hotelshippo.com/");
  };

  return (
    <React.Fragment>
      {showNavigationPop && <div className="navigation-pop-up-background" onClick={CloseNavPopUp}></div>}

      <div className={`new-navigation-pop-up ${showNavigationPop ? "navigation-popup-open" : ""}`}>
        <button className={`popup-navigation-close-btn`} onClick={CloseNavPopUp}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>

        {userId ? (
          <section className="nav-profile-section">
            <button
              id="navbarDropdown"
              className="user_sec header-pop-toggler pop-up-elm profile-button-navbar"
              ref={togglerRef}
              onClick={() => setShowPop((old) => !old)}
              aria-haspopup="true"
              aria-expanded={showPop}
              aria-controls="dropdownMenu"
            >
              <span>
                <GlobalImage src={user.avatar} alt="user profile image" />
              </span>
              <h6>{user.firstName}</h6>
              <NotificationBadge count={unReadTotalCount} className="header-outer" />
            </button>
            <div className="nav-cat-hr"></div>

            <button onClick={goToPartner} className="entry-links">
              List your Property
            </button>

            {show && user?.id && (
              <div
                id="dropdownMenu"
                className={`header-pop user_detail header-pop-side-nav ${show && !showPop && "pop-unmounting"}`}
                ref={popRef}
                role="menu"
                aria-labelledby="navbarDropdown"
              >
                <nav>
                  <ul>
                    <li onClick={CloseNavPopUp}>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li onClick={CloseNavPopUp}>
                      <Link to="/dashboard/wishlist">Wishlist</Link>
                    </li>
                    <li onClick={CloseNavPopUp}>
                      <Link to="/dashboard/messages">
                        Messages
                        <NotificationBadge count={unreadMessagesCount} className="header-inner" />
                      </Link>
                    </li>
                    <li onClick={CloseNavPopUp}>
                      <Link to="/dashboard/notifications">
                        Notifications
                        <NotificationBadge count={unreadNotificationsCount} className="header-inner" />
                      </Link>
                    </li>
                    <li onClick={CloseNavPopUp}>
                      <Link to="/dashboard/profile/edit?type=general">Edit account</Link>
                    </li>

                    <hr />

                    <button onClick={logoutUser}>Logout</button>
                  </ul>
                </nav>
              </div>
            )}
          </section>
        ) : (
          <section>
            <Link to={`/signin`} onClick={CloseNavPopUp}>
              <button className="entry-links">Login</button>
            </Link>

            <Link to={`/signup`} onClick={CloseNavPopUp}>
              <button className="entry-links">Register</button>
            </Link>

            <button onClick={goToPartner} className="entry-links">
              List your Property
            </button>
          </section>
        )}
      </div>
    </React.Fragment>
  );
}
